<template>
  <div>
    <emd-collapse :title="$t('pix')">
      <template v-slot:icon>
        <label class="emd-checkbox">
          <input
            type="checkbox"
            class="emd-checkbox__input"
            v-model="pixEnabled"
          />
          <div class="emd-checkbox__area"></div>
        </label>
      </template>
      <template v-slot:subtitle>
        <span class="subtitle">{{ $t('receiveLabel') }}</span>
      </template>
      <template v-slot:content>
        <div class="eu-flex">
          <div class="eu-flex-item eu-basis_12 eu-basis_4_md">
            <div class="emd-form-group">
              <label class="emd-label">{{ $t('timeToExpire') }} <span class="label-optional">({{ $t('hours') }})</span></label>
              <div class="eu-flex eu-align-items_center">
                <div class="eu-flex-item">
                  <div class="emd-input-group _icon_left _icon_right">
                    <a class="emd-input-icon__link" @click="subtractQuantity">
                      <i class="uil uil-minus"></i>
                    </a>
                    <input
                      :class="{'_state_error': $v.pixSettings.expires_in.$invalid && showFeedbacks.status && pixEnabled}"
                      class="emd-input eu-align_center"
                      v-model="pixSettings.expires_in"
                      @input="filterChar"
                    />
                    <a class="emd-input-icon__link" @click="addQuantity">
                      <i class="uil uil-plus"></i>
                    </a>
                  </div>
                  <p class="emd-input-feedback _state_error" v-if="!$v.pixSettings.expires_in.required && showFeedbacks.status && pixEnabled">
                    {{ $t('hint.required') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <discount class="eu-flex-item eu-basis_12 eu-basis_8_md" v-if="pixSettings.has_discount" @changeDiscount="changeDiscount"/>
          <div class="eu-flex-item eu-basis_12 eu-basis_12_md">
            <div class="emd-form-group eu-py_1_md">
              <label class="emd-checkbox">
                <input
                  type="checkbox"
                  class="emd-checkbox__input"
                  v-model="pixSettings.has_discount"
                />
                <div class="emd-checkbox__area"></div>
                <span class="emd-checkbox__text">
                  {{ $t('discountLabel') }}
                </span>
              </label>
            </div>
          </div>
          <div v-if="pixSettings.has_discount" class="eu-flex-item eu-basis_12 eu-basis_12_md discount-info">
            {{ $t('discountInfo') }}
          </div>
        </div>
      </template>
    </emd-collapse>
  </div>
</template>

<script>
import { EmdCollapse } from 'emerald-vue/src/components'
import Discount from '@/components/project/PaymentMethods/Discount.vue'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'Pix',
  components: {
    EmdCollapse,
    Discount
  },
  computed: {
    showFeedbacks () {
      return this.$store.getters.showFeedbacks
    },
    paymentMethods () {
      return this.$store.getters.paymentMethods.credit_card_enabled
    },
    pixEnabled: {
      get () {
        return this.$store.getters.paymentMethods.pix_enabled
      },
      set (newValue) {
        this.$store.dispatch('PIX_PAYMENT', newValue)
      }
    },
    pixSettings () {
      return this.$store.getters.paymentLinkData.pix_settings
    }
  },
  validations: {
    pixSettings: {
      expires_in: {
        required
      }
    }
  },
  methods: {
    filterChar () {
      this.$emit('formIsValid', this.$v.$invalid)
      this.pixSettings.expires_in = this.pixSettings.expires_in.replace(/[^\d]+/g, '')
    },
    onChangePix (value, attribute) {
      this.$store.dispatch('UPDATE_PIX_DATA',
        {
          value: value,
          attribute: attribute
        }
      )
    },
    changeDiscount (value) {
      this.$store.dispatch('UPDATE_PIX_DATA',
        {
          value: value.discountValue,
          attribute: 'discount'
        }
      )

      this.$store.dispatch('UPDATE_PIX_DATA',
        {
          value: value.discountFormat,
          attribute: 'discount_type'
        }
      )
    },
    subtractQuantity () {
      if (this.pixSettings.expires_in > 1) {
        this.pixSettings.expires_in = Number(this.pixSettings.expires_in) - 1
      }
      this.$emit('formIsValid', this.$v.$invalid)
    },
    addQuantity () {
      if (this.pixSettings.expires_in < 24) {
        this.pixSettings.expires_in = Number(this.pixSettings.expires_in) + 1
      }
      this.$emit('formIsValid', this.$v.$invalid)
    }
  }
}
</script>

<style>
.discount-info {
  color: #72737A;
  padding-top: 4px;
  font-size: 12px;
}
</style>

<i18n>
{
  "pt-BR": {
    "pix": "Pix",
    "shipping": "Valor do frete",
    "timeToExpire": "Tempo até expirar",
    "discountLabel": "Desconto para pagamento no pix",
    "discountValue": "Valor do desconto",
    "discountFormat": "Formato do desconto",
    "receiveLabel": "Receba na hora",
    "hours": "em horas",
    "discountInfo": "O desconto será aplicado sobre o valor da compra e não se aplica ao frete.",
    "hint": {
      "required": "Campo de preenchimento obrigatório"
    }
  },
  "en-US": {
    "pix": "Pix",
    "shipping": "Shipping value",
    "timeToExpire": "Hours to expire",
    "discountLabel": "Pix payment discount",
    "discountValue": "Discount value",
    "discountFormat": "Discount format",
    "receiveLabel": "Receive on time",
    "hours": "in hours",
    "discountInfo": "The discount will be applied to the purchase price and does not apply to shipping.",
    "hint": {
      "required": "This field is required"
    }
  }
}
</i18n>
